import { SongList } from "./SongList"

export const SongListPage = () => (
  <SongList />
)